import React from "react";
import { useEffect, useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import Headerdash from "../pages/head";
import OrderSummary from "./OrderSummary";
import { HashLoader } from "react-spinners"; // Importing the spinner

export default function BillingCheckoutForm({ subscriptionData }) {
  const [loading, setLoading] = useState(false); // To control loading state

  const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
        // Add the border styles here
        border: "1px solid #ced4da",
        borderRadius: "4px",
        padding: "10px",
        backgroundColor: "#fff",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
        // Add the invalid border styles here
        border: "1px solid #fa755a",
      },
    },
    hidePostalCode: true,
  };

  //  Calculation of Price
  const base_Price = subscriptionData?.price; // Base price of the subscription plan
  const plan_Duration = subscriptionData.duration; // Duration of the subscription plan
  const base_gst = 18; // GST rate in percentage

  // Calculate the total price for the given duration
  const total_Price_Before_Gst = base_Price * plan_Duration;

  // Calculate the GST amount
  const plan_Gst = (total_Price_Before_Gst * base_gst) / 100;

  // Calculate the final total price including GST
  const total_Price = total_Price_Before_Gst + plan_Gst;

  //Stipe Integer Pricing

  const strip_Price = total_Price * 100;

  console.log("Total Price Including Gst:", total_Price);

  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [step, setStep] = useState(0); // Track the current step (0 - 4)
  const [isProcessing, setIsProcessing] = useState(false); // Track if processing has started
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [customerId, setCustomerId] = useState(null);

  /* =========================
   1️⃣ FETCH USER + CUSTOMER
========================= */
  useEffect(() => {
    const fetchCurrentSubscription = async () => {
      try {
        const res = await fetch("/api/current-subscription", {
          credentials: "include",
        });

        if (!res.ok) {
          throw new Error("Failed to load user");
        }

        const data = await res.json();

        console.log("CURRENT SUBSCRIPTION API RESPONSE:", data);

        // ✅ Extract from allSubscriptions
        const firstSub = data.allSubscriptions?.[0] || null;

        setCustomerId(firstSub?.customerId || null);
        setUsername(firstSub?.username || null);

        // Optional: set minimal user object if needed
        setUser({
          username: firstSub?.username || "",
          userId: firstSub?.userId || null,
        });

        console.log("CUSTOMER ID SET:", firstSub?.customerId);
        console.log("user ID SET:", firstSub?.username);
      } catch (err) {
        console.error("FETCH USER ERROR:", err);
        setErrorMessage("Unable to load billing information.");
      } finally {
        setLoadingUser(false);
      }
    };

    fetchCurrentSubscription();
  }, []);

  const handleCheckout = async (event) => {
    event.preventDefault();

    setLoading(true);
    setErrorMessage("");
    setIsProcessing(true);
    setStep(0);

    if (!stripe || !elements) {
      setErrorMessage("Stripe not loaded");
      setLoading(false);
      setIsProcessing(false);
      return;
    }

    try {
      setStep(1);

      const cardElement = elements.getElement(CardElement);
      if (!cardElement) {
        setErrorMessage("Card input not found");
        return;
      }

      const { paymentMethod, error: pmError } =
        await stripe.createPaymentMethod({
          type: "card",
          card: cardElement,
          billing_details: {
            email: username,
            name: `${firstname} ${lastname}`,
          },
        });

      if (pmError) {
        setErrorMessage(pmError.message);
        return;
      }

      /* =========================
         4️⃣ CREATE SUBSCRIPTION
      ========================= */
      setStep(2);

      const subRes = await fetch("/api/subscribes", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username,
          customerId,
          paymentMethodId: paymentMethod.id,
          planId: subscriptionData.planID,
          plan: subscriptionData.plan,
          duration: subscriptionData.duration,
          price: subscriptionData.price * 100,
        }),
      });

      // ❌ Stop only on HTTP error
      if (!subRes.ok) {
        const err = await subRes.json().catch(() => ({}));
        setErrorMessage(err.error || "Subscription failed");
        return;
      }

      // ✅ THIS WAS MISSING
      const data = await subRes.json();

      /* =========================
   5️⃣ HANDLE 3DS (if needed)
    ========================= */

      const { clientSecret } = data;
      setStep(3);

      // 🔥 ALWAYS confirm if clientSecret exists
      if (clientSecret) {
        const result = await stripe.confirmCardPayment(clientSecret);

        console.log("CONFIRM RESULT:", result);

        if (result.error) {
          setErrorMessage(result.error.message);
          return;
        }
      }
      /* =========================
   6️⃣ SUCCESS
========================= */
      setStep(4);
      navigate("/success");
      return;
    } catch (err) {
      console.error(err);
      setErrorMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      setIsProcessing(false);
    }
  };

  const steps = [
    "Processing ",
    "Almost There",
    "Payment Processing",
  ];

  return (
    <div>
      <Headerdash />
      <div class="grid  pt-24 sm:px-10 lg:grid-cols-2 lg:px-20 xl:px-32">
        <OrderSummary subscriptionData={subscriptionData} />

        <div class="mt-10 bg-gray-50 px-4 pt-8 lg:mt-0">
          <p class="text-xl font-medium">Payment Details</p>
          <p class="text-gray-400">
            Complete your order by providing your payment details.
          </p>

          <form onSubmit={handleCheckout}>
            <div class=""></div>

            <div class="relative">
              <label
                for="card-holder"
                class="mt-4 mb-2 block text-sm font-medium"
              >
                Card Holder
              </label>
              <div class="relative">
                <input
                  type="text"
                  id="card-holder"
                  name="card-holder"
                  class="w-full rounded-md border border-gray-200 px-4 py-3 pl-11 text-sm uppercase shadow-sm outline-none focus:z-10 focus:border-blue-500 focus:ring-blue-500"
                  placeholder="Your full name here"
                />
                <div class="pointer-events-none absolute inset-y-0 left-0 inline-flex items-center px-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z"
                    />
                  </svg>
                </div>
              </div>
              <label for="card-no" class="mt-4 mb-2 block text-sm font-medium">
                Card Details
              </label>
              {/* Stripe Card Element */}
              <div
                style={{
                  border: "1px solid #ced4da",
                  borderRadius: "4px",
                  padding: "10px",
                  marginBottom: "10px",
                }}
              >
                <CardElement options={CARD_ELEMENT_OPTIONS} />
              </div>
              <label
                for="billing-address"
                class="mt-4 mb-2 block text-sm font-medium"
              >
                Billing Address
              </label>
              <div class="flex flex-col sm:flex-row">
                <div class="relative flex-shrink-0 sm:w-7/12">
                  <input
                    type="text"
                    id="billing-address"
                    name="billing-address"
                    class="w-full rounded-md border border-gray-200 px-4 py-3 pl-11 text-sm shadow-sm outline-none focus:z-10 focus:border-blue-500 focus:ring-blue-500"
                    placeholder="Street Address"
                  />
                  <div class="pointer-events-none absolute inset-y-0 left-0 inline-flex items-center px-3">
                    <img
                      class="h-4 w-4 object-contain"
                      src="https://flagpack.xyz/_nuxt/4c829b6c0131de7162790d2f897a90fd.svg"
                      alt=""
                    />
                  </div>
                </div>
                <select
                  type="text"
                  name="billing-state"
                  class="w-full rounded-md border border-gray-200 px-4 py-3 text-sm shadow-sm outline-none focus:z-10 focus:border-blue-500 focus:ring-blue-500"
                >
                  <option value="State">State</option>
                </select>
                <input
                  type="text"
                  name="billing-zip"
                  class="flex-shrink-0 rounded-md border border-gray-200 px-4 py-3 text-sm shadow-sm outline-none sm:w-1/6 focus:z-10 focus:border-blue-500 focus:ring-blue-500"
                  placeholder="ZIP"
                />
              </div>
            </div>
            {errorMessage && (
              <div className="error-message">
                <p style={{ color: "red" }}>{errorMessage}</p>
              </div>
            )}
            {isProcessing && !errorMessage && (
              <div className="w-full mt-4">
                {/* Progress Container */}
                <div className="relative pt-1">
                  {/* Progress Bar */}
                  <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
                    {" "}
                    {/* Add overflow-hidden here */}
                    <div
                      className="progress-bar progress-bar-striped progress-bar-animated h-2.5 bg-gray-800 rounded-full"
                      style={{
                        width: `${(step / (steps.length - 1)) * 100}%`,
                        transition: "width 0.5s ease-in-out", // Optional smooth transition for progress bar
                      }}
                      aria-valuenow={(step / (steps.length - 1)) * 100}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    />
                  </div>
                </div>
                {/* Step Description */}
                <p className="text-lg text-center text-gray-700 mt-2">
                  {steps[step]}
                </p>
              </div>
            )}

            <button
              type="submit"
              className={`mt-4 mb-8 w-full rounded-md px-6 py-3 font-medium text-white transition-opacity duration-300 ease-in-out ${
                loading
                  ? "opacity-50 cursor-not-allowed bg-gray-700"
                  : "bg-gray-900"
              }`}
              disabled={loading} // Disable button during loading
            >
              {loading ? (
                <div className="flex justify-center items-center">
                  <HashLoader size={20} color="#fff" />
                </div>
              ) : (
                `Pay ${total_Price}`
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
